import React from 'react';
import { Box, Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink } from 'react-router-dom';

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

const TitleBreadCrumbs = ({ pathnames, titlenames }) => {
  return (
    <>
      <Breadcrumbs
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
        sx={{color: 'text.secondary'}}
      >
        <Typography variant="subtitle2" >
          {titlenames[0]}
        </Typography>
        <LinkRouter variant="subtitle2" underline="hover" color="inherit" to={`/${pathnames[0]}`}>
          {titlenames[1]}
        </LinkRouter>
        <Typography variant="subtitle2">{titlenames[2]}</Typography>
      </Breadcrumbs>
    </>
  );
};

export default TitleBreadCrumbs;
